// extracted by mini-css-extract-plugin
export var active = "_fs-7";
export var blink = "_fs-8";
export var dropDownSelector = "_fs-4";
export var dropDownWrapper = "_fs-3";
export var fakeCursor = "_fs-6";
export var fontSizeButton = "_fs-9";
export var formQuillEditor = "_fs-0";
export var pressed = "_fs-a";
export var qlBlank = "_fs-1";
export var textFormattingToolbar = "_fs-2";
export var textToolbarOption = "_fs-5";